// extracted by css-extract-rspack-plugin
export default {"errorFallbackContainer":"ErrorFallback-module__errorFallbackContainer__QLvsi"};